export const ResourceThingTypeMrn = "mrn:sl2:::resource";
